import { useEffect, useState } from 'react';

export default function useBreakpoint(query) {
  const [matches, setMatches] = useState(false); // default: mobil (false)

  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR guard

    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);

    // set initial
    setMatches(mql.matches);

    // listen
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange); // safari fallback

    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return matches;
}